module.exports = __webpack_public_path__ + "img/quiz_header.d28129b.jpg";